import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { L1StaticDatumsEdit } from "./edit";
import { L1StaticDataNew } from "./new";
import { L1StaticDatumsTable } from "./table";
export default function L1StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<L1StaticDatumsEdit />} />
      <Route index element={<L1StaticDatumsTable />} />
      <Route path="/new" element={<L1StaticDataNew />} />
    </Routes>
  );
}
